import React, { useState, useContext, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import TouchesContext from "../../context/touches/touchesContext";
import AuthContext from "../../context/auth/authContext";
import Alerts from "../../components/layout/Alerts";
import Switch from "react-switch";
import { Dropdown } from "react-bootstrap";
import PropTypes from "prop-types";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

const TouchNewClientModal = ({ touch }) => {
  const touchesContext = useContext(TouchesContext);
  const {
    setCurrent,
    clearCurrent,
    current,
    setAlert,
    addClientAndSubscription,
    getDropdowns
  } = touchesContext;

  const authContext = useContext(AuthContext);
  const currentUser = authContext.user.email;

  // const clientsContext = useContext(ClientsContext);
  // const { addClient } = clientsContext;

  const [client, setClient] = useState({
    name: touch.clientName,
    contactName: "",
    contactEmail: "",
    contactPhone: ""
  });

  const { name, contactName, contactEmail, contactPhone } = client;

  const [subscription, setSubscription] = useState({
    appName: "",
    clientId: "",
    licensed: false,
    paidCurrent: false,
    cutOffDate: "",
    terms: "",
    gracePeriodDays: "",
    message: ""
  });

  const {
    licensed,
    paidCurrent,
    cutOffDate,
    terms,
    gracePeriodDays,
    message
  } = subscription;

  useEffect(() => {
    getDropdowns();
    // eslint-disable-next-line
  }, []);

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setCurrent(touch);
    setShow(true);
  };

  const clearAndClose = () => {
    clearCurrent();
    handleClose();
  };

  const onSubmit = e => {
    e.preventDefault();
    if (name !== "") {
      addClientAndSubscription(client, touch, subscription, currentUser);
      clearAndClose();
    } else {
      setAlert("Name cannot be blank", "danger");
    }
  };
  // for changes to client values
  const onClientChange = e => {
    setClient({ ...client, [e.target.name]: e.target.value });
  };
  // for changes to subscription values
  const onSubscriptionChange = e => {
    setSubscription({ ...subscription, [e.target.name]: e.target.value });
  };

  const onChangeLicensed = e => {
    setSubscription({ ...subscription, licensed: e });
  };

  const onChangePaidCurrent = e => {
    setSubscription({ ...subscription, paidCurrent: e });
  };

  const onChangeTerms = e => {
    setSubscription({ ...subscription, terms: e });
  };

  const onChangePhone = value => {
    setClient({ ...client, contactPhone: value });
  };

  const { dropdowns } = touchesContext;

  return (
    <>
      <Button variant="btn btn-success btn-sm" onClick={handleShow}>
        Create Client
      </Button>

      <Modal show={show} onHide={handleClose} dialogClassName="modal-75w">
        <Modal.Header closeButton>
          <Modal.Title className="modalTitleCenter">
            Add Client and Subscription
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alerts />
          <form onSubmit={onSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={name}
              disabled
            />
            <input
              type="text"
              name="contactName"
              placeholder="Contact Name"
              value={contactName}
              onChange={onClientChange}
            />
            <input
              type="email"
              name="contactEmail"
              placeholder="Contact Email"
              value={contactEmail}
              onChange={onClientChange}
            />
            <PhoneInput
              name="contactPhone"
              placeholder="Contact Phone"
              value={contactPhone}
              onChange={onChangePhone}
              country="US"
            />
            <div className="grid-2">
              <label className="container">
                <span className="switchLabel">Licensed: </span>
                <Switch onChange={onChangeLicensed} checked={licensed} />
              </label>
              <label className="container">
                <span className="switchLabel">Paid Current: </span>
                <Switch onChange={onChangePaidCurrent} checked={paidCurrent} />
              </label>
            </div>

            <div className="grid-3">
              <Dropdown
                name="terms"
                value={terms}
                onSelect={onChangeTerms}
                style={{ margin: "auto" }}
                placeholder="Application Name"
              >
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  {terms ? terms : "Terms"}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {dropdowns &&
                    dropdowns
                      .filter(d => d.control === "terms")
                      .map(term => (
                        <Dropdown.Item
                          key={term.id}
                          eventKey={term.storedValue}
                        >
                          {term.displayValue}
                        </Dropdown.Item>
                      ))}
                </Dropdown.Menu>
              </Dropdown>

              <input
                type="date"
                name="cutOffDate"
                value={cutOffDate}
                onChange={onSubscriptionChange}
                placeholder="Terms"
              />
              <input
                type="text"
                name="gracePeriodDays"
                value={gracePeriodDays}
                onChange={onSubscriptionChange}
                placeholder="Grace Days"
              />
            </div>

            <textarea
              name="message"
              cols="30"
              rows="3"
              value={message ? message : ""}
              onChange={onSubscriptionChange}
              placeholder="Message / Notes - this will go out on all api calls"
              maxLength="254"
            ></textarea>
          </form>
          <div>
            <input
              type="submit"
              value={"Add Client"}
              className="btn btn-primary btn-block"
              onClick={onSubmit}
            />
          </div>
          {current && (
            <div>
              <button
                className="btn btn-light btn-block"
                onClick={clearAndClose}
              >
                Clear
              </button>
            </div>
          )}
        </Modal.Body>

        {/* <Modal.Footer></Modal.Footer> */}
      </Modal>
    </>
  );
};

// const modalStyle = {

//   width: '75%',
//   height: '75%'
// };

TouchNewClientModal.propTypes = {
  touch: PropTypes.object.isRequired
};

export default TouchNewClientModal;
